module.exports = __webpack_public_path__ + "img/cle_0.b1c34b68.webp";